/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from 'react';
import {  getDocument, GlobalWorkerOptions } from 'pdfjs-dist/build/pdf'; // Correct imports
import AnimatedModel from '../Animation/AnimatedModel';
import CustomOverLay from '../CustomOverLay';
import { useOnClickOutside } from '../../CommonMethods/OutsideClick';
import { fetchImageAsBlob, getPDFImage, storePDFImage } from './indexdb';

// Set the worker source directly
GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js`; // Update the version as necessary

const HelpGuideModal = ({ pdfUrl, setHelpGuideModel }) => {
    const canvasRef = useRef(null);
    const modalRef = useRef();
    const [cachedImage, setCachedImage] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const getUniquePDFKey = (filePath) => {
        if (!filePath) return "";
        let fileName = filePath.split("?")[0].split("/").pop();
        return fileName.replace(/\.(pdf|png)$/i, "");
    };

    const loadPDF = async (filePath, fullUrl) => {
        setIsLoading(true);
        const pageKey = `${filePath}_page_1`;
    
        try {
            // Try to load from cache first
            const cachedBlob = await getPDFImage(pageKey);
            if (cachedBlob) {
                displayCachedImage(cachedBlob);
                return;
            }
            const imgBlob = await fetchImageAsBlob(fullUrl);
            if (!imgBlob || imgBlob.size < 100) {  // Avoid storing invalid responses
                throw new Error("Invalid PDF received. Not storing in cache.");
            }
            let storagefailed
            try {
                await storePDFImage(pageKey, imgBlob);
            } catch (error) {
                console.error('failed to store')
                storagefailed = true
            }
            if(storagefailed){
                try {
                    const imgURL = URL.createObjectURL(pageKey)
                    setCachedImage(imgURL);
                    setTimeout(() => {
                        URL.revokeObjectURL(imgURL);
                    }, 5000);
                } catch (error) {
                    console.error("Error generating Object URL:", error);
                } 
                return 
            }
            const cachedBlob1 = await getPDFImage(pageKey);
            displayCachedImage(cachedBlob1);
            const loadingTask = getDocument(URL.createObjectURL(imgBlob));
            const pdf = await loadingTask.promise;
            const page = await pdf.getPage(1);
            const viewport = page.getViewport({ scale: 1.5 });
            const canvas = canvasRef.current;
            if (canvas) {
                const ctx = canvas.getContext("2d", { willReadFrequently: true });
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                await page.render({ canvasContext: ctx, viewport }).promise;
                const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/png"));
                if (blob) {
                    await storePDFImage(pageKey, blob);
                    displayCachedImage(blob);
                }
            }
        } catch (error) {
            console.error("Error loading PDF:", error);
        } finally {
            setTimeout(() => {
                setIsLoading(false);
            }, 100);
        }
    };
    

    const displayCachedImage = (blob) => {
        if (!blob || blob.size === 0) {
            console.error("Cached image Blob is null or empty!");
            return;
        } 
        try {
            const imgURL = URL.createObjectURL(blob)
            setCachedImage(imgURL);
    
            setTimeout(() => {
                URL.revokeObjectURL(imgURL);
            }, 5000);
        } catch (error) {
            console.error("Error generating Object URL:", error);
        }
    };

    useEffect(() => {
        if (pdfUrl) {
            const filePath = getUniquePDFKey(pdfUrl);
            loadPDF(filePath, pdfUrl);
        }
    }, [pdfUrl]);

    const handleClose = () => {
        setHelpGuideModel(false);
    };

    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === 'Escape') {
                handleClose();
            }
        };

        document.addEventListener('keydown', handleEscKey);
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, []);

    useOnClickOutside(modalRef, handleClose);

    return (
        <AnimatedModel
            Children={
                <div className="fixed left-0 top-0 z-[1055] h-full w-full overflow-y-auto bg-black bg-opacity-50">
                    <div className="relative flex h-full w-auto items-center mx-auto min-w-[1000px] max-w-[1500px]">
                        <div ref={modalRef} className="flex w-full flex-col rounded-[4px] bg-white shadow-lg h-[85vh] max-w-[1500px] p-4 relative">
                            <img src='/images/closeiconred.png' alt='Close' className='w-[25px] h-[25px] absolute top-3 right-3 cursor-pointer z-[99] bg-white' onClick={handleClose} />
                            <div className="relative mx-auto h-full w-full">
                                {isLoading && <CustomOverLay Active text="Loading HelpGuide PDF..." classKey="absolute z-50 bg-gray-400 opacity-75 flex flex-col items-center w-full h-full justify-center" />}
                                <div className='scrollbar_purpleThin bg-white' style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                                    {cachedImage ? <img src={cachedImage} alt="Cached PDF Preview" style={{ width: '100%' }} /> : <canvas style={{ width: '100%' }} ref={canvasRef}></canvas>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        />
    );
}

export default HelpGuideModal;




